var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99495 0.612838C5.53472 0.612838 5.16162 0.985934 5.16162 1.44617L5.16162 5.67131H0.936477C0.476239 5.67131 0.103145 6.04441 0.103144 6.50465C0.103144 6.96489 0.47624 7.33798 0.936479 7.33798H5.16162L5.16162 11.5631C5.16162 12.0233 5.53472 12.3964 5.99495 12.3964C6.45519 12.3964 6.82829 12.0233 6.82829 11.5631L6.82829 7.33798L11.0534 7.33798C11.5137 7.33798 11.8867 6.96488 11.8867 6.50465C11.8867 6.04441 11.5136 5.67131 11.0534 5.67131L6.82829 5.67131L6.82829 1.44617C6.82829 0.985934 6.45519 0.612838 5.99495 0.612838Z",
    fill: "#1C4A76",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3d0422e76b3d135889f6b5173db615e4.svg";
export { ForwardRef as ReactComponent };